// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// En dev: fallback staging pour que npm run dev pointe toujours vers staging sauf si .env.local override
const STAGING_URL = "https://herycmblynigliyjlctx.supabase.co";
const STAGING_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhlcnljbWJseW5pZ2xpeWpsY3R4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk4OTQ3MzQsImV4cCI6MjA4NTQ3MDczNH0.EkZhtaDMz5zDO6DC4E2UC1Xbyh-0Sa_s4ISS7eweFAQ";
const PROD_URL = "https://qhibjyuubkfscpdgqszg.supabase.co";
const PROD_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFoaWJqeXV1Ymtmc2NwZGdxc3pnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyMDkwMTUsImV4cCI6MjA3Mzc4NTAxNX0.0LXghaMEik3AhNsod_VlFfFQ0kNQI2SFco62ha-cob4";

const isDev = import.meta.env.DEV;
const envUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim();
const envKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();
const SUPABASE_URL = (envUrl && envUrl.startsWith("http")) ? envUrl : (isDev ? STAGING_URL : PROD_URL);
// En dev avec URL staging: toujours utiliser la clé staging pour éviter "Invalid API key" si .env.local a une mauvaise clé
const isStagingUrl = SUPABASE_URL.includes("herycmblynigliyjlctx");
const SUPABASE_PUBLISHABLE_KEY =
  isDev && isStagingUrl
    ? STAGING_ANON_KEY
    : (envKey && envKey.length > 50) ? envKey : (isDev ? STAGING_ANON_KEY : PROD_ANON_KEY);

/** Project ref extracted from SUPABASE_URL (herycmblynigliyjlctx = staging, qhibjyuubkfscpdgqszg = prod) */
export const SUPABASE_PROJECT_REF = (() => {
  try {
    const m = SUPABASE_URL.match(/https:\/\/([^.]+)\.supabase\.co/);
    return m ? m[1] : '';
  } catch {
    return '';
  }
})();

export const IS_STAGING = SUPABASE_PROJECT_REF === 'herycmblynigliyjlctx';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY };

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});